
















import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { TravelType } from '@targomo/core';

@Component
export default class SelectTravelType extends Vue {
  @Prop({ required: true }) value!: 'car' | 'transit' | 'airplane';
  @Prop({ required: true }) travelTypeOptions: ['car', 'transit', 'airplane'];
  travelType = this.value;

  @Emit()
  change(value: 'car' | 'transit' | 'airplane') {
    this.travelType = value;
    return value;
  }
}
